import { Box, Stack, Typography } from "@mui/material";
import Footer from "../../components/Footer";
import { motion } from "framer-motion";
import Head from "next/head";
import Navbar from "../../components/Navbar";
import { services } from "../../utils/data";
import StickyWhatsapp from "../../components/StickyWhatsapp";
import HeroEnquiryForm from "../../components/HeroEnquiryForm";
import { keyframes } from "@emotion/react";


const glow = keyframes`
  from {
    text-shadow: 0 0 10px #1283C4, 0 0 20px #1283C4, 0 0 25px #1283C4;
  }
  to {
    text-shadow: 0 0 10px #1283C4, 0 0 20px #1283C4;
  }
`;
const textAni = {
  offscreen: { y: 20, opacity: 0 },
  onscreen: {
    y: 0,
    opacity: 1,
  },
};
const Services = () => {

  return (
    <>
   <Head>
    <title>Hardware Engineering | Techbrain Networks</title>
    <meta name="description" content="Explore Techbrain Networks expertise in hardware engineering, creating cutting-edge devices that push technological boundaries." />
    
    {/* <!-- Open Graph / Facebook --> */}
    <meta property="og:title" content="Hardware Engineering | Techbrain Networks" />
    <meta property="og:description" content="Explore Techbrain Networks expertise in hardware engineering, where we create cutting-edge devices that push technological boundaries." />
   
    <meta property="og:url" content="https://www.techbrainnetworks.com/services/Hardware-Engineering-Service" />
    <meta property="og:type" content="website" />
    <meta property="og:image" content="https://www.techbrainnetworks.com/logo-tbn.jpg" />
    <meta property="og:image:alt" content="Hardware Engineering at Techbrain Networks" />
    <meta property="og:site_name" content="Techbrain Networks" />
    <meta property="og:locale" content="en_US" />

    {/* <!-- Twitter --> */}
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="Hardware Engineering | Techbrain Networks" />
    <meta name="twitter:description" content="Discover the hardware engineering expertise of Techbrain Networks, creating devices that drive innovation." />
    <meta name="twitter:url" content="https://www.techbrainnetworks.com/services/Hardware-Engineering-Service" />
    <meta name="twitter:image" content="https://www.techbrainnetworks.com/logo-tbn.jpg" />
    <meta name="twitter:image:alt" content="Hardware Engineering at Techbrain Networks" />

    {/* <!-- Additional Meta Tags --> */}
    <meta name="keywords" content="Techbrain Networks, Hardware Engineering, Device Development, Technology Innovation" />
    <meta name="author" content="Techbrain Networks" />
    <meta name="robots" content="index, follow" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <meta name="theme-color" content="#000000" />
    <meta property="og:updated_time" content={new Date().toISOString()} />

    {/* Favicon and Fonts */}
    <link rel="icon" href="/favicon.png" />
    <link rel="preconnect" href="https://fonts.googleapis.com" />
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
    <link href="https://fonts.googleapis.com/css2?family=YourFontFamily:wght@400;700&display=swap" rel="stylesheet" />
</Head>

      <Navbar color="#fff" />
      <StickyWhatsapp link={"https://api.whatsapp.com/send?phone=918754906714"} />
      {/* section 1 */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          height: ["100vh"],
          gap: { xs: 2, sm: 3 },
          bgcolor: "#080f25",
          px: { xs: 2, sm: 0 },
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* plus */}
        <Stack
          component={motion.div}
          animate={{ y: 20 }}
          transition={{
            duration: 2,
            repeat: Infinity,
            repeatType: "reverse",
          }}
          sx={{
            height: ["1rem", "1rem", "1.5rem", "1.8rem", "2rem"],
            position: "absolute",
            left: ["5%"],
            top: ["22%"],
          }}
        >
          <motion.img
            alt="icon"
            animate={{ rotate: 360 }}
            transition={{
              duration: 3,
              repeat: Infinity,
              ease: "linear",
            }}
            src="/plus-p.png"
            style={{ height: "100%" }}
          />
        </Stack>
        {/* star */}
        <Stack
          component={motion.div}
          animate={{ x: -20 }}
          transition={{
            duration: 2,
            repeat: Infinity,
            repeatType: "reverse",
          }}
          sx={{
            height: ["1rem", "1rem", "1.5rem", "2rem", "2rem"],
            position: "absolute",
            bottom: ["9%"],
          }}
        >
          <img alt="icon" src="/star3d-b.png" style={{ height: "100%" }} />
        </Stack>
        {/* star */}
        <Stack
          component={motion.div}
          animate={{ x: 20 }}
          transition={{
            duration: 2,
            repeat: Infinity,
            repeatType: "reverse",
          }}
          sx={{
            height: ["1rem", "1rem", "1.5rem", "2rem", "2rem"],
            position: "absolute",
            right: ["8%"],
            bottom: ["13%"],
          }}
        >
          <img alt="icon" src="/spark-g.png" style={{ height: "100%" }} />
        </Stack>
        {/* star */}
        <Stack
          component={motion.div}
          animate={{ x: 20 }}
          transition={{
            duration: 2,
            repeat: Infinity,
            repeatType: "reverse",
          }}
          sx={{
            height: ["1rem", "1rem", "1.5rem", "2rem", "2rem"],
            position: "absolute",
            left: ["43%"],
            top: ["10%"],
          }}
        >
          <img alt="icon" src="/star3d.png" style={{ height: "100%" }} />
        </Stack>
        <Stack
          sx={{
            display: ["none", "block"],
            width: { xs: ".5rem", xl: "1rem" },
            height: { xs: ".5rem", xl: "1rem" },
            position: "absolute",
            right: ["31%"],
            borderRadius: "100%",
            bgcolor: "#1BDE9C",
            bottom: ["10%"],
          }}
        />
        <Stack
          sx={{
            display: ["none", "block"],
            width: { xs: ".7rem", xl: "1rem" },
            height: { xs: ".7rem", xl: "1rem" },
            position: "absolute",
            left: ["29%"],
            borderRadius: "100%",
            bgcolor: "#f2c444",
            bottom: ["9%"],
          }}
        />
        <Stack
          sx={{
            display: ["none", "block"],
            width: { xs: ".7rem", xl: "1rem" },
            height: { xs: ".7rem", xl: "1rem" },
            position: "absolute",
            right: ["20%"],
            borderRadius: "100%",
            bgcolor: "#ad00ff",
            top: ["29%"],
          }}
        />
        <Stack
          sx={{
            display: ["none", "block"],
            width: { xs: ".5rem", xl: "1rem" },
            height: { xs: ".5rem", xl: "1rem" },
            position: "absolute",
            right: ["22%"],
            borderRadius: "100%",
            bgcolor: "#38b7ff",
            top: ["31%"],
          }}
        />
        {/* star 360 */}
        <Stack
          component={motion.div}
          animate={{ rotate: 360 }}
          transition={{
            duration: 10,
            repeat: Infinity,
            ease: "linear",
          }}
          sx={{
            width: ["1rem", "1rem", "1.5rem", "1.8rem", "2rem"],
            height: ["1rem", "1rem", "1.5rem", "1.8rem", "2rem"],
            position: "absolute",
            left: ["5%"],
            top: ["70%"],
          }}
        >
          <img alt="icon" src="/star4.png" style={{ width: "100%" }} />
        </Stack>
        {/* sqr 360 */}
        <Stack
          component={motion.div}
          animate={{ rotate: 360 }}
          transition={{
            duration: 7,
            repeat: Infinity,
            ease: "linear",
          }}
          sx={{
            width: ["1rem", "1rem", "1.5rem", "1.8rem", "2rem"],
            height: ["1rem", "1rem", "1.5rem", "1.8rem", "2rem"],
            position: "absolute",
            right: ["5%"],
            top: ["25%"],
          }}
        >
          <img alt="icon" src="/square.png" style={{ width: "100%" }} />
        </Stack>
        <Typography
          width={{ xs: "100%", sm: "70%", md: "80%", lg: "85%", xl: "75%" }}
          variants={textAni}
          className="worksans"
          viewport={{ once: true, amount: 0.5 }}
          initial={"offscreen"}
          whileInView={"onscreen"}
          component={motion.h1}
          transition={{ delay: 0.5 }}
          sx={{
            fontSize: ["35px", "50px", "60px", "75px", "90px"],
            textAlign: "center",
            background: "linear-gradient(91.83deg, #FF512F 0%, #DD2476 100%)",
            backgroundClip: "text",
            textFillColor: "transparent",
            fontWeight: [800],
            mb: { xs: 1 },
            lineHeight: ["35px", "55px", "65px", "105px"],
            // animation: `${glow} 2s ease-in-out infinite alternate`,
          }}
        >
           Hardware Engineering
        </Typography>
        <Typography
          width={{ xs: "100%", sm: "80%", md: "85%", lg: "85%", xl: "75%" }}
          variants={textAni}
          className="worksans"
          viewport={{ once: true, amount: 0.5 }}
          initial={"offscreen"}
          whileInView={"onscreen"}
          component={motion.h2}
          transition={{ delay: 0.5 }}
          sx={{
            fontSize: ["20px", "30px", "40px", "45px", "55px"],
            textAlign: "center",
            color: "#fff",
            lineHeight: ["25px", "35px", "50px", "45px", "60px"],
            fontWeight: [800],
            mb: { xs: 1 },
          }}
        >
Our Hardware Engineering Services provide innovative and robust design solutions to keep your business ahead in technology.
        </Typography>
      </Box>

  
      <Box
            
            sx={{
              py: ["1rem", "1rem", "1rem", "2rem"], 
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              px:['1rem','2rem','1rem','1rem','0rem'],
              
            }}
          >
            
            <Box 
            sx={{ mt:[5,5,0], width: "100%", height: "auto", display:'flex', flexDirection:'column', gap:[10,10,0] }}>
              {services.slice(20,25).map((item, index) =>
                index % 2 === 0 ? (
                  <Box
                    sx={{
                      width: "100%",
                      height: ["auto", "auto", "28rem", "35rem", "40rem"],
                      display: "flex",
                      flexDirection: [
                        "column-reverse",
                        "column-reverse",
                        "row",
                      ],
                      justifyContent: "center",
                      alignItems: "center",
                      gap: ["1rem", "1rem", "2rem", "3rem", "4rem"],
                    }}
                  >
                    <Box
                    component={motion.div}
                    initial={{ opacity: 0,y:20 }}
                    whileInView={{ opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeInOut" } }}
                    viewport={{ once: true,amount:.5 }}
                      sx={{
                        width: ["100%", "100%", "40%", "40%", "45%"],
                        height: "auto",
                        display: "flex",
                        flexDirection: "column",
                        gap: "1rem",
                        backgroundColor: "",
                      }}
                    >
                      <Typography
                        sx={{
                          width: ["100%", "100%", "100%"],
                          fontSize: ["1.5rem", "2.2rem", "1.5rem", "2rem", "3rem"],
                          color: item.color,
                          fontWeight: "bold",
                        }}
                      >
                        {item.title}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: [
                            "1rem",
                            "1.5rem",
                            "1rem",
                            "1.5rem",
                            "1.5rem",
                          ],
                          color: "#fff",
                          textAlign: "justify",

                        }}
                      >
                        {item.content}
                      </Typography>
                      <Box sx={{ display: "flex", gap: "1rem" }}>
                        {/* <PrimaryBtn  color={item.color}  href={item.link}>Learn More</PrimaryBtn> */}
                        {/* <SecondaryBtn href={item.link}>Learn More</SecondaryBtn> */}
                      </Box>
                    </Box>
                    <Box
                    component={motion.div}
                    initial={{ opacity: 0,y:20 }}
                    whileInView={{ opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeInOut" } }}
                    viewport={{ once: true,amount:.5 }}
                      sx={{
                        width: ["100%", "100%", "40%", "40%", "40%"],
                        height: ["20rem", "20rem", "20rem", "25rem", "30rem"],
                        backgroundImage: item.icon,
                        backgroundPosition: "center",
                        backgroundSize: "cover",
                        backgroundrepeat: "no-repeat",
                        borderRadius: "16px",
                      }}
                    ></Box>
                  </Box>
                ) : (
                  <Box
                  component={motion.div}
           initial={{ opacity: 0,y:20 }}
           whileInView={{ opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeInOut" } }}
           viewport={{ once: true,amount:.5 }}
                    sx={{
                      width: "100%",
                      height: ["auto", "auto", "28rem", "35rem", "40rem"],
                      display: "flex",
                      flexDirection: ["column",  "column", "row"],
                      justifyContent: "center",
                      alignItems: "center",
                      gap: ["1rem", "1rem", "2rem", "3rem","4rem" ],
                    }}
                  >
                    <Box
                      sx={{
                        width: ["100%", "100%", "40%", "40%", "40%"],
                        height: ["20rem", "20rem", "20rem", "25rem", "30rem"],
                        backgroundImage: item.icon,
                        backgroundPosition: "center",
                        backgroundSize: "cover",
                        backgroundrepeat: "no-repeat",
                        borderRadius: "16px",
                      }}
                    ></Box>
                    <Box
                      sx={{
                        width: ["100%", "100%", "40%", "40%", "45%"],
                        height: "auto",
                        display: "flex",
                        flexDirection: "column",
                        gap: "1rem",
                        backgroundColor: "",
                      }}
                    >
                      <Typography
                        sx={{
                          width: ["100%", "100%", "100%"],
                          fontSize: ["1.5rem", "2.2rem", "1.5rem", "2rem", "3rem"],
                          color: item.color,
                          fontWeight: "bold",
                        }}
                      >
                        {item.title}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: [
                            "1rem",
                            "1.3rem",
                            "1rem",
                            "1.5rem",
                            "1.5rem",
                          ],
                          color: "#fff",
                          textAlign: "justify",

                        }}
                      >
                        {item.content}
                      </Typography>
                      <Box sx={{ display: "flex", gap: "1rem" }}>
                       
                      </Box>
                    </Box>
                  </Box>
                )
              )}
            </Box>
          </Box>
                
      {/* form */}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: ["column"],
          alignItems: "center",
          justifyContent: "center",
          background: "linear-gradient(91.83deg, #080f25 0%, #080f25 100%)",
          gap: ["1.5rem", "3rem", "2rem", "3rem"],
          py: ["4rem", "4.2rem", "2.8rem", "4rem", "8rem"],
          px: ["1rem", "1.2rem", "1.8rem", "4rem", "5rem"],
          color: "#000",
        }}
      >
        <HeroEnquiryForm heroPage />
      </Box>
      <Box
        sx={{
          position: "relative",
          zIndex: 21,
        }}
      >
        <Footer />
        </Box>
    </>
  );
};

export default Services;
